import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography, 
  Box, 
  IconButton 
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'; 
import CloseIcon from '@mui/icons-material/Close'; 

const ORANGE_COLOR = '#FF5F1F'; 

const ErrorModal = ({ open, onClose, errorMessage, errorDetails, onSendErrorEmail }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="error-dialog-title"
      maxWidth="sm" 
      fullWidth 
      sx={{ '& .MuiPaper-root': { borderRadius: '12px' } }} 
    >
      <DialogTitle 
        id="error-dialog-title" 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          bgcolor: ORANGE_COLOR, 
          color: 'white', 
          py: 2, 
          px: 3, 
          borderTopLeftRadius: '12px', 
          borderTopRightRadius: '12px', 
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ErrorOutlineIcon sx={{ mr: 1.5, fontSize: '2rem', color: 'white' }} /> {/* Hata ikonu beyaz */}
          <Typography variant="h6" component="span" sx={{ fontWeight: 'bold' }}>
            Bir Hata Oluştu!
          </Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: 'white',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.2)', 
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 3 }}> 
        <Typography variant="body1" sx={{ mb: 2, color: 'text.primary' }}>
          Üzgünüz, beklenmedik bir sorunla karşılaştık. Lütfen tekrar denemeyi deneyin veya hatayı bize raporlayın.
        </Typography>
        <Typography variant="subtitle2" sx={{ fontStyle: 'italic', color: 'text.secondary', mb: 1 }}>
          Hata Mesajı:
        </Typography>
        <Box 
          sx={{ 
            bgcolor: 'grey.100', 
            p: 1.5, 
            borderRadius: '8px', 
            border: '1px solid', 
            borderColor: 'grey.300',
            fontFamily: 'monospace', 
            whiteSpace: 'pre-wrap', 
            wordBreak: 'break-word', 
            maxHeight: '150px', 
            overflowY: 'auto', 
          }}
        >
          <Typography variant="body2" color="text.primary">
            {errorMessage || 'Detaylı hata mesajı bulunamadı.'}
          </Typography>
        </Box>
        
        {errorDetails && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2" sx={{ fontStyle: 'italic', color: 'text.secondary', mb: 1 }}>
              Hata Detayları:
            </Typography>
            <Box 
              sx={{ 
                bgcolor: 'grey.100', 
                p: 1.5, 
                borderRadius: '8px', 
                border: '1px solid', 
                borderColor: 'grey.300',
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                maxHeight: '150px',
                overflowY: 'auto',
              }}
            >
              <Typography variant="caption" color="text.secondary">
                {errorDetails}
              </Typography>
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 3, justifyContent: 'flex-end' }}> 
        <Button 
          onClick={onClose} 
          color="inherit" 
          variant="outlined" 
          sx={{ 
            mr: 1, 
            borderRadius: '8px',
            borderColor: 'grey.400', 
            color: 'grey.700', 
            '&:hover': {
              bgcolor: 'grey.50',
              borderColor: 'grey.500',
            }
          }} 
        >
          Kapat
        </Button>
        {onSendErrorEmail && (
          <Button 
            onClick={onSendErrorEmail} 
            variant="contained" 
            sx={{ 
              bgcolor: ORANGE_COLOR, 
              color: 'white', 
              borderRadius: '8px', 
              '&:hover': {
                bgcolor: '#E6551C', 
              }
            }}
            startIcon={<ErrorOutlineIcon />} 
          >
            Hatayı Raporla
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;